var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{on:{"input":args => _vm.$emit('close', args)}},[_c('user-avatar',{attrs:{"url":_vm.adviser.avatar,"first-name":_vm.adviser.firstName,"last-name":_vm.adviser.lastName,"size":32,"left":""}}),_vm._v(_vm._s(_vm.adviser.firstName)+" "+_vm._s(_vm.adviser.lastName))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }